"use strict";

import Vue from "vue";
import axios from "axios";
import app from "../main";

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = window.location.origin.replace("adminui", "adminapi").replace("http://localhost:5001", "http://localhost:5000");
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

let config = {
  baseUrl: window.location.origin.replace("adminui", "adminapi"),
  // NOTE: FOR DEV
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control  
  
  // baseURL: window.location.origin.replace(
  //   "http://localhost:5000",
  //   "https://auth-adminapi-dev.omnigo.one"
  // )
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  async (config) => {
    app.$store.dispatch("isLoading", true);
    app.$Progress.start();
    config.headers[
      "Authorization"
    ] = `Bearer ${app.$store.state.oidcStore.access_token}`;
    return config;
  },
  (error) => {
    app.$store.dispatch("isLoading", false);
    app.$Progress.fail();
    Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    app.$store.dispatch("isLoading", false);
    app.$Progress.finish(); // finish when a response is received
    return response;
  },
  function(error) {
    // Do something with response error
    app.$store.dispatch("isLoading", false);
    app.$Progress.fail();
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
